import { useEffect } from 'react'

import ChatService from 'modules/chat/service'
import { ParticipantsUpdateCallback } from 'modules/chat/types'
import { useTransmissionDataContext } from 'modules/transmission/context'
import { useChatContext } from 'modules/chat/context'

const useParticipantUpdate = () => {
  const { code } = useTransmissionDataContext()
  const { isLoaded, setIsMuted } = useChatContext()

  useEffect(() => {
    const participantUpdate: ParticipantsUpdateCallback = response => {
      setIsMuted(!response.permissions.writeMessages)
    }

    code && isLoaded && ChatService.subscribeEvents({ participantUpdate })

    return () => {
      code && isLoaded && ChatService.removeEventSubscription({ participantUpdate })
    }
  }, [code, isLoaded, setIsMuted])
}

export default useParticipantUpdate
